import {DeleteOutlined, EditOutlined, PlusOutlined} from '@ant-design/icons';
import {Button as MuiButton, ThemeProvider} from '@mui/material';
import {Col, Divider, Empty, Input, message, Pagination, Row, Table, Tag} from 'antd';
import Column from 'antd/lib/table/Column';
import ConfirmGroupChange from 'component/settings/managepermission/confirm.groupchange';
import ConfirmPolicyChange from 'component/settings/managepermission/confirm.policychange';
import ConfirmUserDelete from 'component/settings/managepermission/confirm.userdelete';
import CollectiveActionBar from 'component/settings/manageusers/collective_action_bar';
import {aclPermissions, hasPermissions} from 'const/ACLPermissions';
import {error_manager} from 'helper/error_manager';
import {Component} from 'react';
import cookie from "react-cookies";
import {connect} from "react-redux";
import {loadOrganisations, loadUsers} from 'redux_actions/users.action';
import '../asset/style/custom_antd_table_style.css';
import ChangePassword from '../component/settings/manageusers/change.password';
import {changePage, updateUrlStateInReducer, updateUserSearch} from '../redux_actions/search.user.action';
import {getLoggedInUserId, isSuperuser, openEndPoint} from "../utils/utils";

import Close from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import AddGroupButton from 'component/patientfolder/group/AddGroupButton';
import {post} from 'helper/request';
import AddOrganisationModal from "../component/patientfolder/addOrganisation";
import {getAllAccessPolicies} from "../utils/api";
import {Loader} from "../utils/const";
import {defaultTheme} from "../component/gammaviewer/themes";
import DeleteOrganisationModal from "../component/patientfolder/deleteOrganisation";

const {Search} = Input;

const pageSize = 15;

class ManageUsers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedRowKeys: [],
            search: this.props.urlState.search,
            initializationDone: false,
            selectedGroups: [],
            showChangePasswordModel: false,
            showDeleteUserModal: false,
            showChangePolicyModal: false,
            showChangeGroupModal: false,
            selectedUser: {},
            addNewOwner: false,
            newOwnerName: '',
            errorOwnerName: false,
            allPolicies: [],
            selectedGroup: null,
            selectedGroupAction: null,
        }

        this.is_superuser = isSuperuser();
        this.user_id = getLoggedInUserId()
    }

    componentDidMount() {
        this.fetchPolicies()
        this.props.dispatch(updateUrlStateInReducer(this.props.urlState));
        this.props.dispatch(loadOrganisations())
    }

    componentDidUpdate(prevProps, prevState) {
    }

    fetchPolicies = () => {
        const organisation = cookie.load('organisation') || cookie.load('organisation_id')
        getAllAccessPolicies(organisation)
            .then(data => this.setState({allPolicies: data['all_access_policies']}))
    }

    getUsers = (users, selectedGroups) => {
        const allPolicies = this.state.allPolicies || []
        const allGroups = Object.values(this.props.allGroups || {})

        let data = Object.values(users)
        data.sort((a, b) => a?.displayOrder - b?.displayOrder)

        const getPolicy = (user) =>
            allPolicies?.find(p => !!p?.policy_members?.find(m => m.user === user.id))?.name ||
            '-'

        const getOrg = (id) => this.props.allOrganisations?.find(o => o.id === id)?.name || '-'

        const getGroups = (user) =>
            allGroups
                .filter(({id}) => user?.groups?.includes(id))
                .map(({name, id}) => ({name, id}))

        if (selectedGroups.length > 0) {
            data = data.filter(({groups}) =>
                selectedGroups.reduce((prev, curr) => prev || groups.includes(curr), false)
            )
        }

        return data.map(obj => ({
            key: obj?.id,
            username: obj?.username,
            email: obj?.email,
            name: `${obj?.first_name} ${obj?.last_name}`,
            last_login: (hasPermissions([aclPermissions.view_other_user_events]) && obj?.last_login)
                ? new Date(obj?.last_login).toLocaleString() : "-",
            policy: getPolicy(obj),
            groups: getGroups(obj),
            organisation: this.is_superuser ? getOrg(obj?.organisation) : '',
            actions: {
                info: obj,
                actions: ['change_password', 'manage_permissions', 'edit_user']
            }
        }))
    }

    renderGroups = (groups, row) => groups.map(({name, id}, idx) => {
        const limit = 2
        if (idx > limit) return null
        if (idx === limit) return (
            <span>...</span>
        )

        return (
            <Tag
                color={'magenta'}
                key={id}
                onClick={() => this.openChangeGroupModal({
                    selectedGroupAction: "remove",
                    selectedRowKeys: [row.key],
                    selectedGroup: name
                })}
                style={{padding: "0 0 0 4px", cursor: 'pointer'}}
            >
                <div style={{"display": "flex", "justifyContent": "space-between", "alignItems": "center"}}>
                    <span>{name}</span>
                    <Box style={{"height": "22px", "transform": "scale(0.75)"}}>
                        <Close/>
                    </Box>
                </div>
            </Tag>
        )
    })

    editUser = (userInfo) => {
        openEndPoint("/edituser/" + userInfo.id, false, true);
    }

    changePassword = (userInfo) => {
        this.setState({
            showChangePasswordModel: true,
            selectedUser: userInfo,
        });
    }

    closeModal = () => {
        this.setState({
            showChangePasswordModel: false,
        });
    }

    onUserSearch = () => {
        this.setState({
            selectedRowKeys: [],
        })
        this.props.dispatch(updateUserSearch(this.state.search, this.props.urlState));
    }

    onInputChange = (e) => {
        if (e.target.value === '') {
            this.onSearchReset();
        }
        this.setState({
            search: e.target.value,
        });
    }

    onSearchReset = () => {
        if (this.state.search !== '') {
            let search = '';
            this.props.dispatch(updateUserSearch(search, this.props.urlState));
            this.setState({
                search,
                selectedRowKeys: [],
                selectedGroups: [],
            });
        }
    }

    getPaginationDiv = () => {
        return <Pagination
            total={this.props.total}
            showTotal={(total, range) =>
                this.isMobile ? `` : `Showing ${range[0]}-${range[1]} out of ${total} total users`
            }
            current={this.props.urlState.page}
            pageSize={pageSize}
            defaultCurrent={1}
            onChange={this.updatePage}
            size="small"
            className="pagination-mp"
        />
    }

    updatePage = (pageNumber) => {
        this.props.dispatch(changePage(pageNumber, this.props.urlState));
    }

    openAddNewUser = () => {
        openEndPoint("/adduser/", false, true);
    }

    setPolicyUsers = ({usernames, policy}) => {
        const url = '/api/update_members_in_access_policy/'

        post(url, {
            name: policy,
            organisation: cookie.load('organisation_id'),
            action: "add",
            update_member_usernames: usernames
        })
            .then(() => console.log("successfully set user policies"))
            .catch(err => error_manager("Unable to update access policy", err.message))
            .finally(() => {
                setTimeout(() => window.location.reload(), 500)
            })
    }

    setGroupUsers = ({usernames, group, action}) => {
        const url = '/api/update_members_in_group/'

        post(url, {
            group,
            action,
            update_member_usernames: usernames
        })
            .then((data) => {
                if (data?.is_incomplete) {
                    message.warn("Groups changed for users where possible.")
                }
            })
            .catch(err => error_manager("Unable to update user group", err.message))
            .finally(() => this.props.dispatch(loadUsers()))
    }

    openDeleteUserModal = (selectedUser) => this.setState({
        showDeleteUserModal: true,
        selectedUser: selectedUser || null
    })

    openChangePolicyModal = () => this.setState({showChangePolicyModal: true})

    openChangeGroupModal = ({
                                selectedRowKeys = this.state.selectedRowKeys,
                                selectedGroup = null,
                                selectedGroupAction
                            }) => this.setState({
        showChangeGroupModal: true, selectedGroup, selectedRowKeys, selectedGroupAction
    })

    closeDeleteUserModal = (isCancel) => {
        this.setState({showDeleteUserModal: false, selectedUser: {}, selectedRowKeys: [], selectedGroups: []})
        if (!isCancel) {
            message.success("User(s) deleted successfully")
            this.props.dispatch(loadUsers());
        }
    }

    closeChangePolicyModal = () => this.setState({showChangePolicyModal: false})

    closeChangeGroupModal = () => {
        this.setState({
            showChangeGroupModal: false,
            selectedRowKeys: [],
            selectedGroup: null,
            selectedGroupAction: null
        })
    }

    getSelectedUsernames = () => this.state.selectedRowKeys.map((value) => this.props.allUsers[value]?.username)

    renderUserActions = () =>
        <Column
            title="ACTIONS"
            dataIndex="actions"
            key="actions"
            render={({info}) => (
                <Row type="flex" gutter={4}>
                    <Col>
                        <MuiButton
                            variant="outlined"
                            color="primary"
                            size="medium"
                            disabled={!hasPermissions([aclPermissions.update_user])}
                            sx={{fontSize: 10, width: "12px"}}
                            onClick={() => this.editUser(info)}>
                            <EditOutlined style={{height: "12px"}}/>
                        </MuiButton>
                    </Col>
                    <Col>
                        <MuiButton
                            variant="outlined"
                            color="primary"
                            size="medium"
                            disabled={!hasPermissions([aclPermissions.delete_user]) || (info.id === this.user_id)}
                            onClick={() => this.openDeleteUserModal(info)}>
                            <DeleteOutlined style={{height: "12px"}}/>
                        </MuiButton>
                    </Col>
                    <Col>
                        <MuiButton
                            variant="outlined"
                            color="primary"
                            size="small"
                            disabled={!hasPermissions([aclPermissions.update_user]) ||
                                !hasPermissions([aclPermissions.change_other_users_password]) ||
                                info.username === cookie.load('username')}
                            sx={{fontSize: 10}}
                            onClick={() => this.changePassword(info)}>
                            <span>Change Password</span>
                        </MuiButton>
                    </Col>
                </Row>
            )}
        />

    render() {
        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                    selectedRowKeys: selectedRowKeys
                })
            },
            selectedRowKeys: this.state.selectedRowKeys,
            columnWidth: '10px',
        };
        const canManagePolicy = hasPermissions([aclPermissions.create_policy]) ||
            hasPermissions([aclPermissions.edit_policy]) || hasPermissions([aclPermissions.delete_policy])

        return (
            <ThemeProvider theme={defaultTheme}>
                <div className={"full-parent all-slides"}>
                    {/*<Spin tip="Loading..." spinning={this.props.isFetching} delay={500} wrapperClassName={'full-parent'}*/}
                    {/*      indicator={<LoadingOutlined style={{fontSize: 50, marginLeft: '-110px'}} spin/>}*/}
                    {/*      style={{color: '#9C27B0E5'}}>*/}
                    {this.props.isFetching === true ? <Loader loadingText="Loading"/> :
                        <div className={"full-parent"}>
                            <Row>
                                <Col span={24} offset={0} className="all-slides">
                                    <br/>
                                    <Row>
                                        <Col span={this.is_superuser ? 5 : 7}>
                                            <Input
                                                className="antd-to-mui-styling"
                                                value={this.state.search || ''}
                                                onChange={this.onInputChange}
                                                placeholder="Search by Username"
                                                onPressEnter={this.onUserSearch}
                                            />
                                        </Col>
                                        <Col span={1}>
                                            <MuiButton
                                                onClick={this.onSearchReset}
                                                style={{marginLeft: 10}}
                                                variant={"outlined"}
                                                color={"error"} size={"small"}
                                            >
                                                Reset
                                            </MuiButton>
                                        </Col>
                                        <Col span={this.is_superuser ? 18 : 16}
                                             style={{display: "flex", justifyContent: "flex-end", gap: "16px"}}>
                                            {this.is_superuser &&
                                                <MuiButton
                                                    onClick={() => openEndPoint("/orgperms/", false, true)}
                                                    variant={"outlined"}
                                                    color={"primary"} size={"small"}
                                                >
                                                    Manage Organisation Permissions
                                                </MuiButton>}
                                            {this.is_superuser && <AddOrganisationModal/>}
                                            {this.is_superuser && <DeleteOrganisationModal/>}
                                            {canManagePolicy && <MuiButton
                                                onClick={() => openEndPoint("/managepolicy/", false, true)}
                                                variant={"outlined"}
                                                color={"primary"} size={"small"}
                                            >
                                                Manage Policies
                                            </MuiButton>}
                                            <AddGroupButton/>
                                            <MuiButton
                                                onClick={this.openAddNewUser}
                                                variant={"outlined"}
                                                disabled={!hasPermissions([aclPermissions.create_user])}
                                                color={"primary"} size={"small"}
                                                endIcon={<PlusOutlined/>}
                                            >
                                                Add New User
                                            </MuiButton>
                                        </Col>
                                        <br/>
                                        <br/>
                                    </Row>
                                    <Row>
                                        {/* {this.getPaginationDiv()} */}
                                    </Row>
                                    <Divider/>
                                    <Row>
                                        <CollectiveActionBar
                                            openDeleteUserModal={this.openDeleteUserModal}
                                            openChangePolicyModal={this.openChangePolicyModal}
                                            openChangeGroupModal={this.openChangeGroupModal}
                                            selectedUserIds={Object.keys(this.state.selectedRowKeys)}
                                            selectedGroups={this.state.selectedGroups}
                                            setSelectedGroups={(selectedGroups) => this.setState({selectedGroups})}
                                        />
                                    </Row>
                                    <Divider/>
                                    <Row>
                                        <Table
                                            className="custom-hover-table-case custom-table-height custom-table-selection custom-table-header"
                                            dataSource={this.getUsers(this.props.allUsers, this.state.selectedGroups)}
                                            pagination={false}
                                            locale={{emptyText: (<Empty description="No Users Found"/>)}}
                                            rowSelection={rowSelection}
                                            size="small"
                                        >
                                            <Column title="USERNAME" dataIndex="username" key="username"/>
                                            {/* <Column title="Email" dataIndex="email" key="email"/> */}
                                            <Column title="NAME" dataIndex="name" key="name"/>
                                            <Column
                                                title="GROUP"
                                                dataIndex="groups"
                                                key="groups"
                                                render={(groups, row) =>
                                                    (groups?.length > 0 && this.renderGroups(groups, row))
                                                    || <div>-</div>
                                                }
                                            />
                                            {this.is_superuser &&
                                                <Column title="ORG" dataIndex="organisation" key="organisation"/>}
                                            <Column title="ACCESS POLICY" dataIndex="policy" key="policy"/>
                                            <Column title="LAST LOGIN" dataIndex="last_login" key="last_login"/>
                                            {this.renderUserActions()}
                                        </Table>
                                    </Row>
                                    <Row>
                                        {this.getPaginationDiv()}
                                    </Row>
                                </Col>
                            </Row>
                            <ChangePassword modalVisible={this.state.showChangePasswordModel}
                                            selectedUser={this.state.selectedUser} closeModal={this.closeModal}/>
                            {this.state.showDeleteUserModal &&
                                <ConfirmUserDelete
                                    allUsers={this.props.allUsers}
                                    usernames={this.state.selectedUser?.username
                                        ? [this.state.selectedUser?.username]
                                        : this.getSelectedUsernames()}
                                    showModal={this.state.showDeleteUserModal}
                                    closeModal={this.closeDeleteUserModal}
                                />
                            }
                            {this.state.showChangePolicyModal &&
                                <ConfirmPolicyChange
                                    setPolicyUsers={args => this.setPolicyUsers(args)}
                                    usernames={this.getSelectedUsernames()}
                                    showModal={this.state.showChangePolicyModal}
                                    closeModal={this.closeChangePolicyModal}
                                    allPolicies={this.state.allPolicies?.map(e => e.name)}
                                />
                            }
                            {this.state.showChangeGroupModal &&
                                <ConfirmGroupChange
                                    setGroupUsers={args => this.setGroupUsers(args)}
                                    usernames={this.getSelectedUsernames()}
                                    showModal={this.state.showChangeGroupModal}
                                    closeModal={this.closeChangeGroupModal}
                                    allGroups={Object.values(this.props.allGroups)}
                                    selectedGroup={this.state.selectedGroup}
                                    action={this.state.selectedGroupAction}
                                />
                            }
                        </div>
                    }
                </div>
            </ThemeProvider>
        );
    }
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginAlerts.loginStatus,
        allUsers: state.usersReducer,
        numPages: state.searchUserReducer.numPages,
        pageNumber: state.searchUserReducer.pageNumber,
        total: state.searchUserReducer.total,
        urlState: state.searchUserReducer,
        isFetching: state.searchUserReducer.isFetching,
        allGroups: state.searchUserReducer.groups,
        allOrganisations: state.searchUserReducer.organisations,
    };
};

export default connect(mapStateToProps)(ManageUsers);